import React from "react";

interface Props {
  studentNotes: any[];
}

const StudentNoteStatistique: React.FC<Props> = ({ studentNotes }) => {
  const total = studentNotes?.length || 0;
  const validated = studentNotes?.filter((s) => {
    const avg = parseFloat(String(s?.average ?? ""));
    return !isNaN(avg) && avg >= 10;
  }).length;
  const notValidated = total - validated;
  const percent = total > 0 ? ((validated / total) * 100).toFixed(1) : "0.0";

  return (
    <div className="d-flex flex-wrap gap-3 mb-0">
      <div className="card p-2" style={{ minWidth: 160 }}>
        <div className="small text-muted">Nombre de matières</div>
        <div className="h4 mb-0">{total}</div>
      </div>

      <div className="card p-2" style={{ minWidth: 160 }}>
        <div className="small text-muted">Matières validées</div>
        <div className="h4 mb-0 text-success">{validated}</div>
      </div>

      <div className="card p-2" style={{ minWidth: 160 }}>
        <div className="small text-muted">Matières non validées</div>
        <div className="h4 mb-0 text-danger">{notValidated}</div>
      </div>

      <div className="card p-2" style={{ minWidth: 160 }}>
        <div className="small text-muted">Taux de réussite</div>
        <div className="h4 mb-0">{percent}%</div>
      </div>
    </div>
  );
};

export default StudentNoteStatistique;
